module.exports = __webpack_public_path__ + "img/654b4af.jpg";